import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import { axiosHelper } from './helpers/axios';
import VuePiwikPro from '@piwikpro/vue-piwik-pro'
import { PageViews } from '@piwikpro/vue-piwik-pro'

VuePiwikPro.initialize(
  process.env.VUE_APP_PIWIK_PRO_CONTAINER_ID,
  process.env.VUE_APP_PIWIK_PRO_CONTAINER_URL
)
PageViews.trackPageView()

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(axiosHelper, { apiUrl: process.env.VUE_APP_API_URL, store });

app.mount('#app');
